/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineSettingsService() {
        let settingsService = {};
        settingsService.getDeliveryProcessFeatureFlags = function () {
            return localStorageCacheHelper.getDataViaGet(
                "/api/SettingsService/GetDeliveryProcessFeatureFlags",
                localStorageCacheHelper.localStorageKey.deliveryProcessFlagsKey, 
                null, 
                720);
        };
        return settingsService;
    }
    //define globally if it doesn't already exist
    if (typeof (settingsService) === "undefined") {
        window.settingsService = defineSettingsService();
    } else {
        console.log("settingsService already defined.");
    }
})(window);